const PRODUCT_CATEGORY_PATHS = Object.freeze ( {

    tire    : "tyres",

    rim     : "rims",

    battery : "batteries"

} );

const normalizeSlugPart = value => String ( value )

    .normalize ( "NFKD" )

    .replace ( /[\u0300-\u036f]/g, "" )

    .toLowerCase ()

    .replace ( /[^a-z0-9]+/g, "-" )

    .replace ( /^-+|-+$/g, "" );

const normalizeNumericSlugPart = value => {

    if ( value === undefined || value === null || value === "" ) return "";

    const stringValue = String ( value ).trim ();

    if ( ! /^\d+(?:\.\d+)?$/.test ( stringValue ) ) return stringValue;

    const [ integerPart, decimalPart ] = stringValue.split ( "." );
    const normalizedDecimalPart = decimalPart?.replace ( /0+$/, "" );

    return normalizedDecimalPart ? `${ integerPart }.${ normalizedDecimalPart }` : integerPart;

};

const diameterSlugPart = value => {

    if ( value === undefined || value === null || value === "" ) return "";

    const diameter = String ( value ).replace ( /^r/i, "" );

    return `r${ normalizeNumericSlugPart ( diameter ) }`;

};

const slugifyProductFields = product => {

    const fields = [ product?.manufacturer?.name, product?.model ];

    if ( product?.productType === "tire" ) fields.push (

        normalizeNumericSlugPart ( product?.width ),

        normalizeNumericSlugPart ( product?.height ),

        diameterSlugPart ( product?.diameter )

    );

    if ( product?.productType === "rim" ) fields.push (

        normalizeNumericSlugPart ( product?.width ),

        diameterSlugPart ( product?.diameter )

    );

    if ( product?.productType === "battery" ) fields.push (

        normalizeNumericSlugPart ( product?.voltage ),

        normalizeNumericSlugPart ( product?.capacity ),

        normalizeNumericSlugPart ( product?.current )

    );

    return fields

        .filter ( value => value !== undefined && value !== null && value !== "" )

        .map ( normalizeSlugPart )

        .filter ( Boolean )

        .join ( "-" );

};

const buildProvisionalProductSlug = product => {

    const productId = product?.id;

    if ( productId === undefined || productId === null || !/^\d+$/.test ( String ( productId ) ) ) {

        throw new TypeError ( "A numeric product ID is required to build a provisional slug" );

    }

    return [ slugifyProductFields ( product ), String ( productId ) ]

        .filter ( Boolean )

        .join ( "-" );

};

const extractProductIdFromProvisionalSlug = slug => {

    if ( typeof slug !== "string" || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test ( slug ) ) return null;

    const match = slug.match ( /(?:^|-)(\d+)$/ );

    return match ? match[ 1 ] : null;

};

const getProductCategoryPath = productType => PRODUCT_CATEGORY_PATHS[ productType ];

const productMatchesCategory = ( product, expectedProductType ) => {

    const productCategoryPath = getProductCategoryPath ( product?.productType );
    const expectedCategoryPath = getProductCategoryPath ( expectedProductType );

    return Boolean ( productCategoryPath && productCategoryPath === expectedCategoryPath );

};

const buildCategoryPath = productType => {

    const categoryPath = getProductCategoryPath ( productType );

    if ( ! categoryPath ) throw new TypeError ( `Unsupported product type: ${ productType }` );

    return `/shop/${ categoryPath }`;

};

const buildProvisionalProductPath = product => {

    const categoryPath = getProductCategoryPath ( product?.productType );

    if ( ! categoryPath ) throw new TypeError ( `Unsupported product type: ${ product?.productType }` );

    return `/shop/${ categoryPath }/${ buildProvisionalProductSlug ( product ) }`;

};

module.exports = {

    slugifyProductFields,

    buildProvisionalProductSlug,

    extractProductIdFromProvisionalSlug,

    buildCategoryPath,

    buildProvisionalProductPath,

    getProductCategoryPath,

    productMatchesCategory

};